import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { useActiveSellerFulfillmentProviders } from '../../../../hooks/use-seller-fulfillment-providers';

import DataDrivenLogo from '../../../../components/data-driven-logo';
import ConnectedList from '../connected-list';
import messages from './messages';
import { CarrierStatus } from '../../../../enums/carriers';

function ConnectedProviderList({ sellerLabelProviders }) {
  const sellerFulfillmentProviders = useActiveSellerFulfillmentProviders();
  const providersReferenceData = useSelector(Global.selectReferenceDatagetProviders);

  const providersReferenceHash = useMemo(() => {
    return providersReferenceData.reduce((hash, provider) => {
      return {
        ...hash,
        [provider.labelProviderId]: provider,
      };
    }, {});
  }, [providersReferenceData]);

  const connectedProvidersData = useMemo(() => {
    return sellerLabelProviders.map((provider) => ({
      name: provider.name ? provider.name : providersReferenceHash[provider.labelProviderId]?.name,
      id: provider.sellerLabelProviderId,
      logo: <DataDrivenLogo logoType='icon' providerId={Number.parseInt(provider.labelProviderId, 10)} />,
      connectedMessage:
        provider.status === CarrierStatus.Pending ? (
          <FormattedMessage {...messages.pendingStatus} />
        ) : (
          <FormattedMessage {...messages.connected} />
        ),
      createdTime: new Date(provider.createDateUtc).getTime(),
    }));
  }, [sellerLabelProviders, providersReferenceHash]);

  const connectedFulfillmentProvidersData = useMemo(() => {
    return sellerFulfillmentProviders.map((provider) => {
      return {
        name: provider.name,
        id: provider.sellerFulfillmentProviderId,
        logo: <DataDrivenLogo fillProviderId={Number.parseInt(provider.fulfillmentProviderId, 10)} logoType='icon' />,
        connectedMessage: <FormattedMessage {...messages.connected} />,
        createdTime: new Date(provider.createDateUtc).getTime(),
      };
    });
  }, [sellerFulfillmentProviders]);

  const allConnectedProviders = useMemo(() => {
    return [...connectedProvidersData, ...connectedFulfillmentProvidersData];
  }, [connectedProvidersData, connectedFulfillmentProvidersData]);

  return <ConnectedList items={allConnectedProviders} />;
}

ConnectedProviderList.propTypes = {
  sellerLabelProviders: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      labelProviderId: PropTypes.string,
    }),
  ).isRequired,
};

export default ConnectedProviderList;
